"use strict";

if (document.getElementById("app_services")) {
  var vueServicesFiles = new Vue({
    delimiters: ['[[', ']]'],
    el: '#app_services_files',
    data: function data() {
      return {
        files: []
      };
    },
    mounted: function mounted() {
      $.ajaxSetup({
        traditional: true
      });
    },
    methods: {
      getServicesFiles: function getServicesFiles() {
        this.files = [];
        $.ajax({
          url: '/api/v1/member_services/file_type',
          method: 'GET',
          beforeSend: function beforeSend(request) {
            return request.setRequestHeader("Accept-Language", languageCode);
          },
          success: function success(response) {
            // var results = response.results
            vueServicesFiles.files = response;
            setTimeout(function () {
              $('#app_services_files').find('.js-panel-checkbox').panelCheckboxServices();
              checkUrlParameters(files_services, 'files');
            }, 500);
          },
          error: function error(_error) {}
        });
      }
    }
  });
  vueServicesFiles.getServicesFiles();
}